import type { PricingList } from 'api/types/pricing.types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { toFixed } from 'utils/helpers';

const StyledDiv = styled(Row)<{ serviceType?: PricingList.ServiceTypes }>`
  display: inline-flex;
  padding: 7px 10px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 10000px;
  background: ${({ theme }) => theme.components.orderInstructions.priceView.backgroundColor};
  height: 32px;
`;

const Styledh5 = styled.h5`
  color: ${({ theme }) => theme.colors.darkForestGreen};
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.1px;
`;

const StyledTag = styled.p`
  color: ${({ theme }) => theme.colors.darkForestGreen};
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.6px;
`;

interface PriceViewProps {
  currency?: string;
  price: number;
}

const PriceView = ({ price, currency }: PriceViewProps) => (
  <Col className="mb-7">
    <StyledDiv>
      <Styledh5>
        +{currency} {toFixed(price, 0)}
      </Styledh5>{' '}
      <StyledTag>per pair</StyledTag>
    </StyledDiv>
  </Col>
);

export default PriceView;
